import { render, staticRenderFns } from "./MdtColorPicker.vue?vue&type=template&id=19c0ad0d&scoped=true"
import script from "./MdtColorPicker.vue?vue&type=script&lang=js"
export * from "./MdtColorPicker.vue?vue&type=script&lang=js"
import style0 from "./MdtColorPicker.vue?vue&type=style&index=0&id=19c0ad0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c0ad0d",
  null
  
)

export default component.exports